import React from "react"
import PropTypes from "prop-types"

import ServiceTile from "./service_tile"
import Header from "./header"
import Subtitle from "./subtitle"

import "./index.scss"

const ServiceSelection = ({
  channels,
  onNext,
  toggleChannel,
  showFooter,
  channelSelected,
  newUserOnboarding,
}) => {
  let subtitleCopy = `To help you get personalized recommendations, pick at least
    <br />
    one of the following that you use regularly.`

  let headerTitle = newUserOnboarding ? "Welcome to IFTTT!" : "Applet Wizard"

  return (
    <>
      <Header title={headerTitle} />
      <div styleName="container">
        <div>
          <Subtitle>{subtitleCopy}</Subtitle>
          <ul styleName="service-list">
            {channels.map(c => (
              <li key={c.module_name}>
                <ServiceTile
                  onClick={() => toggleChannel(c.module_name)}
                  channel={c}
                  selected={channelSelected(c.module_name)}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      {showFooter && (
        <footer styleName="onboarding-footer">
          <div styleName="wide-content">
            <div>Great choices! Let&rsquo;s learn about Applets now.</div>
            <button
              onClick={onNext}
              className="button-tertiary button-on-color"
            >
              Continue
            </button>
          </div>
          <div styleName="narrow-content">
            <button
              onClick={onNext}
              className="button-tertiary button-on-color"
            >
              Continue
            </button>
          </div>
        </footer>
      )}
    </>
  )
}

ServiceSelection.propTypes = {
  channels: PropTypes.array.isRequired,
  channelSelected: PropTypes.func.isRequired,
  newUserOnboarding: PropTypes.bool,
  onNext: PropTypes.func.isRequired,
  showFooter: PropTypes.bool.isRequired,
  toggleChannel: PropTypes.func.isRequired,
}

export default ServiceSelection
